import baseClient from './baseClient';

const getPlayerList = async (year = "current") => {
    return baseClient.get(`player/all/${year}`);
}

const getPlayer = async (playerId) => {
    return baseClient.get(`player/${playerId}`);
}

const editPlayer = async(id, player) => {
    return baseClient.patch(`player/${id}`, player);
}

const deletePlayer = async(id) => {
    return baseClient.delete(`player/${id}`);
}

const addPlayer = async({firstName, lastName, positionName, value, pcId}) => {
    return baseClient.post(
        'player/add',
        {
            firstName: firstName,
            lastName: lastName,
            positionName: positionName,
            value: value,
            pcId: pcId
        }
    );
}

const uploadCSVFile = async({importCSV}) => {

    const formData = new FormData();
    formData.append('importCSV', importCSV);

    return baseClient.post('player/upload-csv', formData);
}

const importMultiplePlayers = async(playersToImport) => {
    return baseClient.post(
        'player/add-multiple',
        {
            players: playersToImport
        }
    );
}

const updateMultiplePlayers = async(playersToSave) => {
    return baseClient.patch(
        'player/update-multiple',
        {
            players: playersToSave
        }
    );
}

const editPlayerMatchData = async(playerId, gamePlayerId, matchData) => {
    return baseClient.patch(`player/match-data/${playerId}/${gamePlayerId}`, matchData);
}

const removePlayerFromMatch = async(playerId, gamePlayerId) => {
    return baseClient.delete(`player/match-data/${playerId}/${gamePlayerId}`);
}

const addPlayerToMatch = async ({matchId, playerId}) => {
    return baseClient.post(`match/${matchId}/add-player`, { playerId });
}

const getPlayerStats = async (playerId) => {
    return baseClient.get(`player/stats/${playerId}`);
}

const getArchivePlayerStandingYears = async (playerId) => {
    return baseClient.get(`player/${playerId}/archive-tables`);
}

const getArchivePlayerGameweekData = async (playerId, year) => {
    return baseClient.get(`player/${playerId}/archive-data/${year}`);
}

const getPlayerPriceChanges = async (playerId) => {
    return baseClient.get(`price-changes/${playerId}`);
}

const updatePlayerPriceChanges = async (playerId, gameweek, priceChange) => {
    return baseClient.post(
        `price-changes/${playerId}`,
        {
            priceChange: priceChange,
            gameweek: gameweek
        }
    );
}

const getArchivePlayerSeasons = async () => {
    return baseClient.get('player/archive-tables');
}


export {
    getPlayerList,
    getPlayer,
    getPlayerStats,
    editPlayer,
    deletePlayer,
    addPlayer,
    importMultiplePlayers,
    updateMultiplePlayers,
    editPlayerMatchData,
    removePlayerFromMatch,
    addPlayerToMatch,
    getArchivePlayerSeasons,
    getArchivePlayerStandingYears,
    getArchivePlayerGameweekData,
    getPlayerPriceChanges,
    updatePlayerPriceChanges,
    uploadCSVFile
}
